import { TFeature, IFeatureProperties } from '../../types/map';
import { IClusterSchema } from '../../repositories/search-engine/entities/cluster/ClusterSchema';

type TAdditionalFeaturesParams = Partial<{ [key in keyof IFeatureProperties]: IFeatureProperties[key] }>;

export function prepareFeatures(clusters: IClusterSchema[], additionalParams?: TAdditionalFeaturesParams): TFeature[] {
  return clusters.map(
    ({
      bbox,
      clusterOfferIds,
      coordinates,
      count,
      favoriteIds,
      geohash,
      hasNewobject,
      isViewed,
      minPrice = null,
      specialPromo,
      subdomain,
    }) => {
      return {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [coordinates.lat, coordinates.lng],
        },
        id: geohash,
        properties: {
          bbox,
          clusterOfferIds,
          count,
          favoriteIds,
          hasNewobject,
          isViewed: isViewed || false,
          minPrice,
          specialPromo,
          subdomain,
          ...additionalParams,
        },
      };
    },
  );
}
